import axios from "axios";
import React, { createContext, useCallback, useMemo, useState } from "react";
import API_BASE_URL from "../config/api";

export const PoppupContext = createContext();

export const PoppupContextProvider = ({ children }) => {
  const [sliderName, setSliderName] = useState("");
  // link image to slider
  const linkSliderMedia = useCallback((SliderId, fileName) => {
    axios
      .post(
        `${API_BASE_URL}/linktoslider/${SliderId}/images/${fileName}`,
        {},
        {
          headers: {
            myToken: localStorage.getItem("myToken"),
          },
        }
      )
      .then((res) => {
        if (res.data.error) {
          alert("Veuillez d'abord vous authentifier");
        } else {
          console.log("Image liée à la diapositive avec succès");
          setSliderName(res.data.sliderName);
        }
      })
      .catch((error) => console.log(error));
  }, []);

  const contextValue = useMemo(
    () => ({
      sliderName,
      setSliderName,
      linkSliderMedia,
    }),
    [sliderName, linkSliderMedia]
  );



  return (
    <PoppupContext.Provider value={contextValue}>
      {children}
    </PoppupContext.Provider>
  );
};
